// src/features/leases/components/NotSpecified.jsx
//
// LSE6 — muted "Not specified" placeholder. Per memo: indicates a
// gap-fill opportunity without screaming. Inline edit on click is
// owned by the parent EditableLeaseField wrapper.

import React from "react";
import { T } from "../../../app/tokens.js";

export function NotSpecified() {
  return (
    <span
      data-testid="not-specified"
      style={{
        color: T.light,
        fontStyle: "italic",
        fontSize: T.fsBase,
        fontWeight: T.fwRegular,
      }}
    >
      Not specified
    </span>
  );
}
